export type InputStyleVariantType = "filled" | "outlined" | "standard";
export const inputStyleVariant: InputStyleVariantType = "standard";
